export function timeline() {
    gsap.registerPlugin(ScrollTrigger);

    const steps = document.querySelectorAll(".timeline-step");

    steps.forEach((step) => {
        const line = step.querySelector(".timeline-step__line");

        // Lijn voorbereiden
        if (line) {
            gsap.set(line, { scaleY: 0, transformOrigin: "top center" });
        }

        ScrollTrigger.create({
            trigger: step,
            start: "top 50%",
            end: "bottom 50%",
            onEnter: () => {
                step.classList.add("timeline-step--active");

                if (line) {
                    gsap.to(line, {
                        scaleY: 1,
                        duration: 1.2,
                        ease: "power2.out"
                    });
                }
            },
            onLeaveBack: () => {
                step.classList.remove("timeline-step--active");

                if (line) {
                    gsap.to(line, {
                        scaleY: 0,
                        duration: 0.6,
                        ease: "power2.inOut"
                    });
                }
            }
        });
    });
}